import React, { Component } from 'react';

import {Image, Transformation, CloudinaryContext} from 'cloudinary-react';

import scrollToElement from 'scroll-to-element';

class Banner extends React.Component {
	
    constructor(){
        super()

        this.scrollHandle = this.scrollHandle.bind();
    }

    scrollHandle() {
        scrollToElement('.scroll-stop');
    }

    render() {
		return (
            <section className="carousel">
                <img className="static" src={this.props.url} />
                <div className="container">
                    <div className="table-wrapper">
                        <div className="table-cell">
                            <h2>{this.props.pageName}</h2>
                            <p>{this.props.pageDesc}</p>
                            <span className="pe-7s-angle-down-circle" onClick={this.scrollHandle}></span>
                        </div>
                    </div>
                </div>
            </section>
		);
	}
}

export default Banner;



// WEBPACK FOOTER //
// ./src/Common/Banner.js